import React, { useEffect } from 'react'
import { InvestmentCard } from 'src/components/Global/Cards/Cards'
import { useTypedSelector } from 'src/redux/root-reducer'
import { getUserInvestmentAction } from 'src/redux/actions/invest'
import { useDispatch } from 'react-redux'
import { MyInvestmentWrapper } from './myInvsetmentStyle'
import { GeneralSpinner } from 'src/components/Global/Spinner/Spinner'
import { NoInvestmentSvg } from 'src/assets/index'
import { addNairaSign } from 'src/utils/addNairaSign'

const Myinvestment = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getUserInvestmentAction())
  }, [dispatch])

  const investData = useTypedSelector((state) => state.invest.user.investments)
  // const investLoading = useTypedSelector((state) => state.invest.loading)

  console.log(investData)

  return (
    <MyInvestmentWrapper>
      {investData?.map((item: any) => {
        return (
          <InvestmentCard>
            <div className="card_header">
              <img
                src={item.investment_plan.image}
                className="card_img"
                alt=""
              />
            </div>
            <div className="card_body">
              <h3 className="card_title">{item.investment_plan.plan_name}</h3>

              <div className="amount_date_wrapper">
                <div className="amount">
                  <p className="amount_title">Amount invested</p>
                  <p className="amount_text">{item.amount_invested}</p>
                </div>
                <div className="maturity_date">
                  <p className="maturity_title">Maturity date</p>
                  <p className="maturity_text">{item.maturity_date}</p>
                </div>
              </div>
              <div className="roi">
                <p className="roi_text">
                  <span> {item.roi}</span> return in{' '}
                  {item.investment_plan.duration} months
                </p>
              </div>
            </div>
          </InvestmentCard>
        )
      })}

      {investData?.length === 0 && (
        <div className="no_investment_img">
          <img src={NoInvestmentSvg} alt="" />
          <p>No investment. Invest now!</p>
        </div>
      )}
    </MyInvestmentWrapper>
  )
}

export { Myinvestment }
